// apps/crm-frontend/src/pages/ProfilePage.tsx
// 個人資料頁：版面與表單是 @redpanda/ui 的 ProfileSettings（7 系統共用，R26），這裡只接 API 與 toast
import React, { useContext } from 'react';
import { toast } from 'react-hot-toast';
import { ProfileSettings } from '@redpanda/ui';
import { identityApi } from '../services/api';
import { UserContext } from '../context/UserContext';
import { setCrossDomainCookie } from '@redpanda/utils';

const ProfilePage: React.FC = () => {
  const userContext = useContext(UserContext);
  const user = userContext?.user;

  return (
    <ProfileSettings
      isLoading={userContext?.isLoading}
      user={user && { name: user.name, email: user.email, organizationName: user.organization?.name, role: user.role }}
      onUpdateName={async (name) => {
        await identityApi.patch('/auth/me', { name });
        await userContext?.refreshUser();
      }}
      onChangePassword={async (oldPassword, newPassword) => {
        const { data: changed } = await identityApi.post('/auth/change-password', { oldPassword, newPassword });
        // 改密碼後其他裝置的登入會失效，這台換用回傳的新 token（寫回自己網域的 cookie）
        if (changed?.token) setCrossDomainCookie('auth_token', changed.token, '.redpanda-tech.com');
      }}
      notify={toast}
    />
  );
};

export default ProfilePage;
